import { useTheme } from '@mui/material';

import { Icons, HexIcon, Button, Typography, Stack } from '@cast/design-system';

import { useCostReportContext } from 'features/cost-report/hooks/useCostReportContext';
import { useCastctlOnboardingDialog } from 'hooks/dialogs';
import { getThemeColor } from 'utils/theme';

export const ReliabilityMetricsNotInstalled = () => {
  const theme = useTheme();
  const { refetchCapabilities } = useCostReportContext();
  const { openCastctlOnboardingDialog } = useCastctlOnboardingDialog();

  const handleEnableReliabilityMetrics = () => {
    openCastctlOnboardingDialog({
      skipConnectionMonitoring: true,
      initialFeatureSelection: { reliabilityMetrics: true },
      onCompleted: () => {
        refetchCapabilities();
      },
    });
  };

  return (
    <Stack
      alignItems="center"
      alignSelf="center"
      data-testid="reliability-metrics-not-installed"
      gap={8}
      mt={16}
    >
      <HexIcon
        variant="notification"
        icon={
          <Icons.ChartBar
            color={getThemeColor(theme, 'blue.500')}
            weight="fill"
          />
        }
        size={72}
      />
      <Typography
        variant="h5"
        lineHeight="28px"
        data-testid="reliability-metrics-not-installed-title"
      >
        Monitor reliability across your services
      </Typography>
      <Typography
        textAlign="center"
        variant="P14R"
        color="textSecondary"
        maxWidth={480}
      >
        Install the reliability metrics collector to track availability, request
        throughput, error rates, and latency. Analyze reliability trends across
        your cluster from a single view.
      </Typography>
      <Button
        variant="primary"
        size="md"
        startIcon={<Icons.Code weight="bold" />}
        testId="enable-reliability-metrics-button"
        onClick={handleEnableReliabilityMetrics}
      >
        Enable reliability metrics
      </Button>
    </Stack>
  );
};
